import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary } from './error-boundary'
import { RealtimeProvider } from '@/components/realtime/RealtimeProvider'
import { PermissionProvider } from '@/shared/auth/permission-context'
import { queryPolicies } from '@/shared/api/query-policies'

// Admin pages should render cached server state immediately and refresh
// intentionally from page-specific hooks or mutations.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...queryPolicies.catalog,
    },
  },
})

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <PermissionProvider>
          <RealtimeProvider>
            {children}
          </RealtimeProvider>
        </PermissionProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
